import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';

export class CookiebotConfig extends NgxCookiebotConfig {
  override blockingMode = 'manual';
  override cbId = '0437f784-602d-48f0-a96c-0a459edd84dc';
  override cdn = 'eu';
  override loadScript = true;
}
